import React, { useEffect } from "react";
import HeroBg from "../../assets/images/hero-bg.png";
import HeroCar from "../../assets/images/herocar.png";
import "aos/dist/aos.css";
import AOS from "aos";

export const HeroText = ({ centered = false }: { centered?: boolean }) => (
  <div
    className={`h-full flex flex-col justify-center px-0 lg:px-8 ${
      centered ? "items-center text-center" : "items-center lg:items-start"
    }`}
  >
    <div
      className="text-4xl lg:text-6xl font-bold font-mazzardbold my-2"
      data-aos="fade-right"
    >
      Fusion Cab
    </div>
    <div
      className={`my-1 text-xl lg:text-2xl text-center w-full font-mazzardextralight ${
        centered ? "" : "lg:text-left"
      }`}
      data-aos="fade-right"
      data-aos-delay="200"
    >
      Let’s Revolutionize Cab Services
    </div>
    <div
      className={`my-3 text-center text-sm text-gray-700 ${
        centered ? "" : "lg:text-left"
      }`}
      data-aos="fade-right"
      data-aos-delay="400"
    >
      Fusion Cab is redefining the commercial cab rental industry by
      transforming an often disorganized sector into an efficient,
      technology-driven ecosystem.
    </div>
  </div>
);

interface HeroSectionProps {
  // The booking engine - full-width row on top.
  left: React.ReactNode;
}

// Two rows: booking engine full-width on top (room to stay horizontal
// without cramping), car graphic below it - the map graphic is a full-bleed
// background behind both, so it doesn't need its own box. Tagline text lives
// outside this component, below the whole banner.
const HeroSection = ({ left }: HeroSectionProps) => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <div className="w-full relative rounded-xl overflow-hidden">
      <div
        className="absolute inset-0 z-0 bg-no-repeat bg-center bg-cover opacity-60"
        style={{ backgroundImage: `url(${HeroBg})` }}
      ></div>
      <div className="absolute inset-0 z-0 bg-gradient-to-br from-white/60 via-white/80 to-white/60 pointer-events-none"></div>

      <div className="relative z-10 p-5 lg:p-10">
        {/* Row 1: booking engine */}
        <div className="w-full">{left}</div>

        {/* Row 2: car graphic, nudged up toward the booking engine and
            right-aligned */}
        <div
          className="mt-4 -translate-y-4 lg:-translate-y-8 flex justify-center lg:justify-end"
          data-aos="fade-left"
          data-aos-delay="300"
        >
          <img
            alt=""
            src={HeroCar}
            className="animate-slideInRight w-full max-w-[560px] h-auto object-contain"
          />
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
